import { getArticlePath } from 'dpl/prismic/utils';

export function normalizeLinks(links) {
  return links.map(({ link, title }) => {
    const href = link.url ? link.url : getArticlePath(link);
    return {
      href,
      isActive: window.location.pathname.endsWith(href),
      title
    };
  });
}
